import { colors } from './colors';

export const vyPalette = {
  ...colors,
  primary: {
    main: colors.blue[100],
    light: '#7492FF',
    dark: colors.blue[90],
    contrastText: '#fff',
  },
  secondary: {
    main: colors.purple[100],
    light: colors.purple[50],
    dark: colors.purple[90],
    contrastText: '#fff',
  },
  success: {
    main: colors.green[100],
    light: colors.green[50],
    dark: colors.green[90],
    contrastText: '#fff',
  },
  warning: {
    main: colors.yellow[100],
    light: colors.yellow[50],
    dark: colors.yellow[90],
    contrastText: '#fff',
  },
  error: {
    main: colors.red[100],
    light: colors.red[50],
    dark: colors.red[90],
    contrastText: '#fff',
  },
  info: {
    main: colors.softPurple[100],
    light: colors.softPurple[50],
    dark: colors.softPurple[90],
    contrastText: '#fff',
  },
  text: {
    primary: '#152232',
    secondary: '#7E8796',
    disabled: colors.grey[50],
  },
  background: {
    default: colors.grey[10],
    paper: colors.grey[20],
  },
  divider: colors.grey[30],
};
